import _mergeJSXProps from "babel-helper-vue-jsx-merge-props";
export default {
  name: 'Temp',
  functional: true,
  render: function (h, ctx) {
    return h(
      "svg",
      _mergeJSXProps([{
        attrs: { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }
      }, ctx.data]),
      [h("path", {
        attrs: { d: "M16 32c-3.93 0-7.11-3.18-7.11-7.11 0-1.8.68-3.44 1.78-4.69V5.33C10.67 2.39 13.05 0 16 0c2.94 0 5.33 2.39 5.33 5.33V20.2a7.083 7.083 0 0 1 1.78 4.69c0 3.93-3.18 7.11-7.11 7.11zm1.78-10.17V5.33c0-.98-.8-1.78-1.78-1.78s-1.78.8-1.78 1.78v16.49c-1.06.62-1.78 1.75-1.78 3.06 0 1.96 1.59 3.56 3.56 3.56s3.56-1.59 3.56-3.56c0-1.3-.72-2.44-1.78-3.05zM16 27.56a2.67 2.67 0 0 1-2.67-2.67c0-1.16.74-2.14 1.78-2.5v-9.11h1.78v9.11c1.03.37 1.78 1.34 1.78 2.5 0 1.47-1.2 2.67-2.67 2.67z" }
      })]
    );
  }
};